import { Button, ButtonProps } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";

type FormSubmitProps = ButtonProps;

export default function FormReset({
  variant = "ghostDimmed",
  size = "sm",
  children = "Reset",
  onClick,
  ...props
}: FormSubmitProps) {
  const {
    formState: { isSubmitting, isDirty },
    reset,
  } = useFormContext();

  return (
    isDirty && (
      <Button
        isDisabled={props.isDisabled || isSubmitting}
        size={size}
        type="button"
        variant={variant}
        onClick={(e) => {
          reset();
          onClick?.(e);
        }}
        {...props}
      >
        {children}
      </Button>
    )
  );
}
